/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */
import { reduxForm, SubmissionError } from 'redux-form';
import { postOrganization } from 'actions/orgCreators';
import { PROBLEM_WITH_REQUEST, SELECT_AT_LEAST_ONE_MODEL_TYPE } from 'constants/errorMessages';
import calculateOrgRequestBody from 'support/calculateOrgRequestBody';
import CreateOrganizationForm from './CreateOrganizationForm';

const onSubmit = (values, dispatch) => {
  if (!values.standard && !values.advanced) {
    return Promise.reject(new SubmissionError({ _error: SELECT_AT_LEAST_ONE_MODEL_TYPE }));
  }
  return dispatch(postOrganization(calculateOrgRequestBody(values)))
    .catch(() => Promise.reject(new SubmissionError({ _error: PROBLEM_WITH_REQUEST })));
};

export default reduxForm({
  onSubmit,
  form: 'createOrganization',
})(CreateOrganizationForm);



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/CreateOrganization/CreateOrganizationForm/index.js